export const GENRE_ID = 'genreId';
export const CATEGORY_ID = 'categoryId';

